import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'; // eslint-disable-line

export const PLUGIN_NAME = 'lightboxGallery';

export let initPhotoSwipeFromDOM = function(galleryElement, globalOpts = {}) {
  const ACTIONS_ROLE = 'lightbox-actions';

  const parseThumbnailElements = (wrapper) => {
    const items = [];
    const $wrapper = $(wrapper);
    const $childrenNodes = $wrapper.children();
    const numChildNodes = $childrenNodes.length;
    for (let i = 0; i < numChildNodes; i++) {
      const $child = $childrenNodes.eq(i);
      if ($child.attr('role') === ACTIONS_ROLE) {
        continue;
      }

      const img = $child.find('img').get(0);
      const size = getSizeFromImage(img);
      const parentSrc = img.parentElement.dataset.srcLarge;
      const item = {
        src: parentSrc || img.src,
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
        el: img,
      };

      if (img.alt) {
        item.title = img.alt;
      }

      items.push(item);
    }

    return items;
  };

  const getSizeFromImage = (img) => {
    let size = (img.parentElement.dataset.size || '')
      .toLowerCase()
      .split('x')
      .filter((s) => s);

    if (!size.length) {
      size = [img.naturalWidth, img.naturalHeight];
    }

    return size;
  };

  // find nearest parent element
  let closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  let onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    let eTarget = e.target || e.srcElement;
    // find root element of slide
    let clickedListItem = closest(eTarget, function(el) {
      return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    let clickedGallery = clickedListItem.parentNode;
    let childNodes = clickedListItem.parentNode.childNodes;
    let numChildNodes = childNodes.length;
    let nodeIndex = 0;
    let index;

    for (let i = 0; i < numChildNodes; i++) {
      const childNode = childNodes[i];
      if (childNode.nodeType !== 1 || childNode.getAttribute('role') === ACTIONS_ROLE) {
        continue;
      }

      if (childNode === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (clickedListItem.classList.contains('photo-gallery--lastest-disabled')) {
      openLinkLatest(e);
      return false;
    }

    if (index >= 0) {
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  let photoswipeParseHash = function() {
    let hash = window.location.hash.substring(1);
    let params = {};

    if (hash.length < 5) {
      return params;
    }

    let vars = hash.split('&');
    for (let i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      let pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  const openLinkLatest = (e) => {
    const $element = $(e.target);
    let url = $element.attr('href');

    if (!url) {
      url = $element.find('.photo-gallery__count').attr('href');
    }

    if (url) {
      window.location.href = url;
    }
  };

  const openPhotoSwipe = (index, galleryElement, disableAnimation, fromURL) => {
    let pswpElement = $('.pswp').get(0);
    let options;
    let items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {

      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

      getThumbBoundsFn: function(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        let thumbnail = items[index].el;
        let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        let rect = thumbnail.getBoundingClientRect();

        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width,
        };
      },

    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (let j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    options = {
      ...options,
      ...globalOpts,
    };

    const plugin = $(galleryElement).data(PLUGIN_NAME);
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    if (plugin) {
      plugin.setPswp(gallery);
    }

    gallery.init();

    const $actions = $(`[role="${ACTIONS_ROLE}"]`, $(galleryElement));
    const hasActions = $actions.length && $actions.children().length;
    let $pswpActionsWrapper;

    if (hasActions) {
      $pswpActionsWrapper = $('.pswp .pswp__primary-actions');
      $actions.children().appendTo($pswpActionsWrapper);
      $pswpActionsWrapper.removeClass('hidden');
    }

    if (hasActions && $pswpActionsWrapper.length) {
      gallery.listen('close', function() {
        $pswpActionsWrapper.addClass('hidden');
        $pswpActionsWrapper.children().appendTo($actions);
      });
    }
  };

  // loop through all gallery elements and bind events
  let galleryElements = [galleryElement];

  for (let i = 0, l = galleryElements.length; i < l; i++) {
    const galleryElementChild = galleryElements[i];
    galleryElementChild.setAttribute('data-pswp-uid', i + 1);
    galleryElementChild.onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  let hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};
